// extracted by mini-css-extract-plugin
export default {"handle":"Xog3SB"};